export default __webpack_public_path__ + "static/media/youfirst-bureau-logo.f3533816.png";